import { Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';

/**
 * User menu with avatar initial and logout.
 * Replaces Clerk's <UserButton />.
 */
export function UserMenu() {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  const initial =
    user?.firstName?.[0]?.toUpperCase() ||
    user?.email?.[0]?.toUpperCase() ||
    '?';

  return (
    <div className="flex items-center gap-2 sm:gap-3">
      <Link
        to="/account"
        className="flex h-9 w-9 items-center justify-center rounded-full bg-indigo-600 text-sm font-medium text-white hover:opacity-90"
        title={`${user?.email} — Account settings`}
      >
        {initial}
      </Link>
      <Link
        to="/account"
        className="hidden text-sm font-medium text-gray-600 hover:text-gray-900 sm:inline"
      >
        Account
      </Link>
      <Link
        to="/help"
        className="hidden text-sm font-medium text-gray-600 hover:text-gray-900 sm:inline"
      >
        Help
      </Link>
      <button
        type="button"
        onClick={handleLogout}
        className="inline-flex min-h-[2.75rem] items-center whitespace-nowrap px-2 text-sm font-medium text-gray-600 hover:text-gray-900"
      >
        Sign out
      </button>
    </div>
  );
}

export default UserMenu;
